import { createIconComponent } from '../../factory/create-icon-component';
export const ArrowRightUpIcon = createIconComponent(
  'ArrowRightUpIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 20L20 4M20 4V15M20 4H9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
